import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, Heart, MessageSquare, Mail, AtSign, Award } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, Spinner, Empty, Time } from "@/forum/ui";

const ICONS = { reply: MessageSquare, like: Heart, message: Mail, mention: AtSign, role: Award };

export default function NotificationsPage() {
  const [items, setItems] = useState(null);
  const { refresh } = useAuth();

  useEffect(() => {
    api.get("/forum/notifications").then(async (r) => {
      setItems(r.data);
      if (r.data.some((n) => !n.read)) {
        await api.post("/forum/notifications/read");
        refresh();
      }
    });
  }, [refresh]);

  return (
    <div className="mx-auto max-w-3xl space-y-6" data-testid="notifications-page">
      <div>
        <p className="eyebrow mb-3">Értesítések</p>
        <h1 className="font-display text-3xl font-bold">Mi történt?</h1>
      </div>
      {!items ? <Spinner /> : items.length === 0 ? <Empty text="Nincs értesítésed" testId="no-notifications" /> : (
        <Panel className="overflow-hidden">
          <div className="divide-y divide-white/[0.05]">
            {items.map((n) => {
              const I = ICONS[n.kind] || Bell;
              return (
                <Link key={n.id} to={n.link} className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-white/[0.03] ${n.read ? "" : "bg-[rgba(94,177,255,0.05)]"}`} data-testid={`notification-${n.id}`}>
                  <span className={`grid h-9 w-9 place-items-center rounded-full border ${n.read ? "border-white/10 text-white/50" : "border-[rgba(94,177,255,0.5)] text-[var(--glow)]"}`}><I size={14} /></span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-white/85">{n.text}</p>
                    <Time iso={n.created_at} />
                  </div>
                  {!n.read && <span className="h-2 w-2 rounded-full bg-[var(--glow)]" />}
                </Link>
              );
            })}
          </div>
        </Panel>
      )}
    </div>
  );
}
